// extracted by mini-css-extract-plugin
module.exports = {"container":"CourseCTA_container__9QCX5","title":"CourseCTA_title__wWlWH","buttonContainer":"CourseCTA_buttonContainer__mHfoB"};